import React from "react";
import { Box } from "@chakra-ui/react";
import { NavbarWithCallToAction } from "../components/chakra/NavbarWithCallToAction/NavbarWithCallToAction";
import { FooterWithFourColumns } from "../components/chakra/FooterWithFourColumns/FooterWithFourColumns";
import { useAuth } from "../contexts/AuthContext";
import { useDocumentTitle } from "../hooks/useDocumentTitle";
import { useIndustry } from "./home/tokens";
import { StaffLoginView } from "./home/StaffLoginView";
import { BackOfficeView } from "./home/BackOfficeView";
import AdminModuleLinks from "../components/AdminModuleLinks";

/**
 * Home — the TalentLink+ back office front door, built to the Claude Design
 * artboard `clients/talent-link-plus/brand/design/Back Office.dc.html`.
 *
 *   signed out → StaffLoginView  (the artboard's "Staff login" state)
 *   signed in  → BackOfficeView  (the artboard's "Dashboard" state, populated
 *                from the real Prospecting + Employees modules)
 *
 * Site chrome (navbar + footer) stays the app's own; the artboard's top bar
 * and user chip are mocks and are not ported.
 */
const Home: React.FC = () => {
  const { isAuthenticated } = useAuth();
  const t = useIndustry();
  useDocumentTitle(undefined, isAuthenticated ? "Overview" : "Staff sign in");

  return (
    <Box bg={t.ground} minH="100vh" overflowX="hidden">
      <NavbarWithCallToAction />
      {isAuthenticated ? (
        <>
          {/* Quick links — the same permission-filtered, per-user customisable grid
              PLCC and master show at the top of the home page after login. */}
          <AdminModuleLinks />
          <BackOfficeView />
        </>
      ) : (
        <StaffLoginView />
      )}
      <FooterWithFourColumns />
    </Box>
  );
};

export default Home;
